import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// bulk create reservation
export const bulkCreateReservations = createAsyncThunk(
    "PartnerReservation/bulk-create-reservations",
    async (reservationData: any) => {
        try {
            const result = await axios.post(
                `partner-bulk-create-reservations`,
                reservationData,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return error.response.data;
        }
    },
);

// bulk update reservation
export const bulkUpdateReservations = createAsyncThunk(
    "PartnerReservation/bulk-update-reservations",
    async (reservationData: any, { rejectWithValue }) => {
        try {
            const result = await axios.put(
                `partner-bulk-update-reservations`,
                reservationData,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);

// get All partner reservation
export const getReservationList = createAsyncThunk(
    "PartnerReservation/get-reservations-list",
    async (
        {
            page,
            currentPage,
            limit,
        }: { page: number; currentPage: number; limit: number },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.get(`partner-get-reservations-list`, {
                withCredentials: true,
                params: {
                    page,
                    currentPage,
                    limit,
                },
            });
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// Bulk cancel Reservation
export const bulkCancelReservations = createAsyncThunk(
    "PartnerReservation/bulk-cancel-reservations",
    async (reservationData: any, { rejectWithValue }) => {
        try {
            const result = await axios.put(
                `partner-bulk-cancel-reservations`,
                reservationData,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);
// cancel partner reservation
export const cancelSingleReservation = createAsyncThunk(
    "PartnerReservation/cancel-reservation",
    async (
        { reservationID, data }: { reservationID: String | undefined; data: any },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.put(
                `partner-cancel-reservation/${reservationID}`,
                data,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);

// get reservation details
export const getReservationDetails = createAsyncThunk(
    "PartnerReservation/get-reservation-details",
    async (reservationNumber: any, { rejectWithValue }) => {
        try {
            const result = await axios.get(
                `partner-get-reservation-details/${reservationNumber}`,
                {
                    withCredentials: true,
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get reservation details
export const getArchivedReservationDetails = createAsyncThunk(
    "PartnerReservation/get-archived-reservation-details",
    async (reservationNumber: any, { rejectWithValue }) => {
        try {
            const result = await axios.get(
                `partner-get-archived-reservation-details/${reservationNumber}`,
                {
                    withCredentials: true,
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get All partner archived reservation
export const getArchivedReservationsList = createAsyncThunk(
    "PartnerReservation/get-archived-reservations-list",
    async (
        {
            page,
            currentPage,
            limit,
        }: { page: number; currentPage: number; limit: number },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.get(
                `partner-get-archived-reservations-list`,
                {
                    withCredentials: true,
                    params: {
                        page,
                        currentPage,
                        limit,
                    },
                },
            );
            if (!result.data.Success) {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get list of reservation to be exported on csv file
export const exportReservationsList = createAsyncThunk(
    "PartnerReservation/export-reservations-list",
    async (data: any, { rejectWithValue }) => {
        try {
            const result = await axios.post(
                `partner-export-reservations-list`,
                data,
                {
                    withCredentials: true,
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);
// resend reservation qrcode
export const resendPartnerReservation = createAsyncThunk(
    "PartnerReservation/resend-reservation",
    async (data: any, { rejectWithValue }) => {
        try {
            const result = await axios.post(`partner-resend-reservation`, data, {
                withCredentials: true,
            });

            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// Bulk delete Reservations
export const bulkDeleteReservations = createAsyncThunk(
    "PartnerReservation/bulk-delete-reservations",
    async (reservationData: any, { rejectWithValue }) => {
        try {
            const result = await axios.put(
                `partner-bulk-delete-reservations`,
                reservationData,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);
// delete partner reservation
export const deleteSingleReservation = createAsyncThunk(
    "PartnerReservation/delete-reservation",
    async (
        { reservationID, data }: { reservationID: String | undefined; data: any },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.put(
                `partner-delete-reservation/${reservationID}`,
                data,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);

// get event names list
export const getEventNamesList = createAsyncThunk(
    "PartnerReservation/get-event-names-list",
    async (parkingId: any, { rejectWithValue }) => {
        try {
            const result = await axios.get(
                `partner-get-event-names-list/${parkingId}`,
                {
                    withCredentials: true,
                },
            );
            if (!result.data.Success) {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get All partner ungrouped reservation
export const getUngroupedReservations = createAsyncThunk(
    "PartnerReservation/get-ungrouped-reservations-list",
    async (
        {
            page,
            currentPage,
            limit,
        }: { page: number; currentPage: number; limit: number },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.get(`partner-get-ungrouped-reservations`, {
                withCredentials: true,
                params: {
                    page,
                    currentPage,
                    limit,
                },
            });
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get single reservation details
export const getSingleReservationDetails = createAsyncThunk(
    "PartnerReservation/get-single-reservation-details",
    async (reservationId: any, { rejectWithValue }) => {
        try {
            const result = await axios.get(
                `partner-get-single-reservation-details/${reservationId}`,
                {
                    withCredentials: true,
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get All partner reservation
export const getUngroupedArchivedReservations = createAsyncThunk(
    "PartnerReservation/get-ungrouped-archived-reservations-list",
    async (
        {
            page,
            currentPage,
            limit,
        }: { page: number; currentPage: number; limit: number },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.get(
                `/partner-get-ungrouped-archived-reservations`,
                {
                    withCredentials: true,
                    params: {
                        page,
                        currentPage,
                        limit,
                    },
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get reservation details
export const getSingleArchivedReservationDetails = createAsyncThunk(
    "PartnerReservation/get-single-archived-reservation-details",
    async (reservationId: any, { rejectWithValue }) => {
        try {
            const result = await axios.get(
                `partner-get-single-archived-reservation-details/${reservationId}`,
                {
                    withCredentials: true,
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// single update reservation
export const updateSingleReservation = createAsyncThunk(
    "PartnerReservation/update-single-reservation",
    async (
        { reservationID, data }: { reservationID: String | undefined; data: any },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.put(
                `partner-update-single-reservation/${reservationID}`,
                data,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);

export const getUpdatedReservationsDetails = createAsyncThunk(
    "PartnerReservation/get-updated-reservations-details",
    async (reservationNumber: any, { rejectWithValue }) => {
        try {
            const result = await axios.get(
                `partner-get-updated-reservations-details/${reservationNumber}`,
                {
                    withCredentials: true,
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const exportGroupedReservations = createAsyncThunk(
    "PartnerReservation/export-grouped-reservation",
    async (reservationNumber: string, { rejectWithValue }) => {
        try {
            const result = await axios.get(
                `partner-export-grouped-reservations/${reservationNumber}`,
                {
                    withCredentials: true,
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const exportArchivedGroupedReservations = createAsyncThunk(
    "PartnerReservation/export-archived-grouped-reservation",
    async (reservationNumber: string, { rejectWithValue }) => {
        try {
            const result = await axios.get(
                `partner-export-archived-grouped-reservations/${reservationNumber}`,
                {
                    withCredentials: true,
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get All partner ungrouped reservation
export const filterGroupedReservations = createAsyncThunk(
    "PartnerReservation/filter-grouped-reservations-list",
    async (
        {
            query,
            carType,
            status,
            startDate,
            endDate,
            actionType,
        }: {
            query: string | null;
            carType: string;
            status: string;
            startDate: string | Date | null;
            endDate: string | Date | null;
            actionType: "FILTER" | "RESET" | "FETCH" | null;
        },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.get(
                `partner-filter-grouped-reservations`,
                {
                    withCredentials: true,
                    params: {
                        query,
                        carType,
                        status,
                        startDate,
                        endDate,
                        actionType,
                    },
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get All partner ungrouped reservation
export const filterUngroupedReservations = createAsyncThunk(
    "PartnerReservation/filter-ungrouped-reservations-list",
    async (
        {
            query,
            carType,
            status,
            startDate,
            endDate,
            actionType,
        }: {
            query: string | null;
            carType: string;
            status: string;
            startDate: string | Date | null;
            endDate: string | Date | null;
            actionType: "FILTER" | "RESET" | "FETCH" | null;
        },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.get(
                `partner-filter-ungrouped-reservations`,
                {
                    withCredentials: true,
                    params: {
                        query,
                        carType,
                        status,
                        startDate,
                        endDate,
                        actionType,
                    },
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get All partner ungrouped reservation
export const filterArchivedGroupedReservations = createAsyncThunk(
    "PartnerReservation/filter-archived-grouped-reservations-list",
    async (
        {
            query,
            carType,
            status,
            startDate,
            endDate,
            actionType,
        }: {
            query: string | null;
            carType: string;
            status: string;
            startDate: string | Date | null;
            endDate: string | Date | null;
            actionType: "FILTER" | "RESET" | "FETCH" | null;
        },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.get(
                `partner-filter-archived-grouped-reservations`,
                {
                    withCredentials: true,
                    params: {
                        query,
                        carType,
                        status,
                        startDate,
                        endDate,
                        actionType,
                    },
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get All partner ungrouped reservation
export const filterArchivedUngroupedReservations = createAsyncThunk(
    "PartnerReservation/filter-archived-ungrouped-reservations-list",
    async (
        {
            query,
            carType,
            status,
            startDate,
            endDate,
            actionType,
        }: {
            query: string | null;
            carType: string;
            status: string;
            startDate: string | Date | null;
            endDate: string | Date | null;
            actionType: "FILTER" | "RESET" | "FETCH" | null;
        },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.get(
                `partner-filter-archived-ungrouped-reservations`,
                {
                    withCredentials: true,
                    params: {
                        query,
                        carType,
                        status,
                        startDate,
                        endDate,
                        actionType,
                    },
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// * unarchive grouped reservations
export const unarchiveGroupedReservations = createAsyncThunk(
    "PartnerReservation/unarchive-grouped-reservations",
    async (reservationData: any, { rejectWithValue }) => {
        try {
            const result = await axios.put(
                `partner-unarchive-grouped-reservations`,
                reservationData,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);

// * unarchive single reservation
export const unarchiveSingleReservation = createAsyncThunk(
    "PartnerReservation/unarchive-single-reservation",
    async (
        { reservationID, data }: { reservationID: String | undefined; data: any },
        { rejectWithValue },
    ) => {
        try {
            const result = await axios.put(
                `partner-unarchive-single-reservation/${reservationID}`,
                data,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);

// * export archived reservations
export const exportArchivedReservationsList = createAsyncThunk(
    "PartnerReservation/export-archived-reservations-list",
    async (data: any, { rejectWithValue }) => {
        try {
            const result = await axios.post(
                `partner-export-archived-reservations-list`,
                data,
                {
                    withCredentials: true,
                },
            );
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// get event names list
export const getArchivedEventNamesList = createAsyncThunk(
    "PartnerReservation/get-archived-event-names-list",
    async (parkingId: any, { rejectWithValue }) => {
        try {
            const result = await axios.get(
                `partner-get-archived-event-names-list/${parkingId}`,
                {
                    withCredentials: true,
                },
            );
            if (!result.data.Success) {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    },
);

// delete partner reservation
export const deleteMultipleReservationEvents = createAsyncThunk(
    "PartnerReservation/delete-multiple-Reservation-events",
    async (data: any, { rejectWithValue }) => {
        try {
            const result = await axios.put(
                `partner-delete-multiple-Reservation-events`,
                data,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);

// delete multiple partner reservation
export const deleteMultipleReservations = createAsyncThunk(
    "PartnerReservation/delete-multiple-reservations",
    async (data: any, { rejectWithValue }) => {
        try {
            const result = await axios.put(
                `partner-delete-multiple-reservations`,
                data,
                {
                    withCredentials: true,
                },
            );
            if (result.data.Success) {
                toast.success(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(result.data.Description, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            return result.data;
        } catch (error: any) {
            toast.error(error.response.data.Description, {
                position: toast.POSITION.TOP_RIGHT,
            });
            return rejectWithValue(error.response.data);
        }
    },
);

const PartnerReservation = createSlice({
    name: "partnerReservations",
    initialState: {
        reservation: {},
        loading: false,
        success: false,
        description: null,
        availablePlaces: null,
        exportedReservations: [],
        eventNames: [],
        groupedReservations: [],
        ungroupedReservations: [],
        pagination: null,
    },
    reducers: {
        clearErrors: (state) => {
            state.description = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // * bulk add reservation
            .addCase(bulkCreateReservations.pending, (state) => {
                state.success = false;
                state.loading = true;
                state.description = null;
            })
            .addCase(bulkCreateReservations.fulfilled, (state, action) => {
                state.success = action.payload.Success;
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(bulkCreateReservations.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * bulk update reservation
            .addCase(bulkUpdateReservations.pending, (state) => {
                state.success = false;
                state.loading = true;
                state.description = null;
            })
            .addCase(bulkUpdateReservations.fulfilled, (state, action) => {
                state.success = action.payload.Success;
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(bulkUpdateReservations.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * get all partner reservation
            .addCase(getReservationList.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getReservationList.fulfilled, (state, action) => {
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.pagination;
            })
            .addCase(getReservationList.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * gc cancel reservation
            .addCase(cancelSingleReservation.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(cancelSingleReservation.fulfilled, (state, action) => {
                state.loading = false;
                state.reservation = action.payload.Reservation;
                state.ungroupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(cancelSingleReservation.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * bulk cancel reservation
            .addCase(bulkCancelReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(bulkCancelReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.reservation = action.payload.Reservation;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(bulkCancelReservations.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * get reservation details
            .addCase(getReservationDetails.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getReservationDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.reservation = action.payload.Reservation;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(getReservationDetails.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * resend reservation qrcode
            .addCase(resendPartnerReservation.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(resendPartnerReservation.fulfilled, (state, action) => {
                state.loading = false;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(resendPartnerReservation.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * get all partner archived reservations
            .addCase(getArchivedReservationsList.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getArchivedReservationsList.fulfilled, (state, action) => {
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.pagination;
            })
            .addCase(
                getArchivedReservationsList.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )
            // * get partner reservations list to be exported
            .addCase(exportReservationsList.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(exportReservationsList.fulfilled, (state, action) => {
                state.loading = false;
                state.exportedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(exportReservationsList.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * get archived reservation details
            .addCase(getArchivedReservationDetails.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getArchivedReservationDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.reservation = action.payload.Reservation;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(
                getArchivedReservationDetails.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )
            // * gc delete reservation
            .addCase(deleteSingleReservation.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(deleteSingleReservation.fulfilled, (state, action) => {
                state.loading = false;
                state.reservation = action.payload.Reservation;
                state.ungroupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(deleteSingleReservation.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * bulk delete reservation
            .addCase(bulkDeleteReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(bulkDeleteReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.reservation = action.payload.Reservation;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(bulkDeleteReservations.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })
            // * get event names
            .addCase(getEventNamesList.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getEventNamesList.fulfilled, (state, action) => {
                state.loading = false;
                state.eventNames = action.payload.EventNames;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(getEventNamesList.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })

            // * get all partner ungrouped reservation
            .addCase(getUngroupedReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getUngroupedReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.ungroupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(getUngroupedReservations.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })

            // * get all partner ungrouped archived reservation
            .addCase(getUngroupedArchivedReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getUngroupedArchivedReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.ungroupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(
                getUngroupedArchivedReservations.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )

            // * get all partner single reservation details
            .addCase(getSingleReservationDetails.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getSingleReservationDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.reservation = action.payload.Reservation;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(
                getSingleReservationDetails.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )

            // * get all partner single archived reservation details
            .addCase(getSingleArchivedReservationDetails.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(
                getSingleArchivedReservationDetails.fulfilled,
                (state, action) => {
                    state.loading = false;
                    state.reservation = action.payload.Reservation;
                    state.success = action.payload.Success;
                    state.description = action.payload.Description;
                },
            )
            .addCase(
                getSingleArchivedReservationDetails.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )
            // * get updated reservation details
            .addCase(getUpdatedReservationsDetails.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getUpdatedReservationsDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.reservation = action.payload.Reservation;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(
                getUpdatedReservationsDetails.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )
            // * update single reservation
            .addCase(updateSingleReservation.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(updateSingleReservation.fulfilled, (state, action) => {
                state.loading = false;
                state.ungroupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(updateSingleReservation.rejected, (state: any, action: any) => {
                state.loading = false;
                state.success = false;
                state.description = action.payload.Description;
            })

            // * export selected grouped reservation
            .addCase(exportGroupedReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(exportGroupedReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.exportedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(
                exportGroupedReservations.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )

            // * export selected archived grouped reservation
            .addCase(exportArchivedGroupedReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(exportArchivedGroupedReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.exportedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(
                exportArchivedGroupedReservations.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )
            // * filter grouped reservations
            .addCase(filterGroupedReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(filterGroupedReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.pagination;
            })
            .addCase(
                filterGroupedReservations.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )
            // * filter ungrouped reservations
            .addCase(filterUngroupedReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(filterUngroupedReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.ungroupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.pagination;
            })
            .addCase(
                filterUngroupedReservations.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )

            // * filter archived grouped reservations
            .addCase(filterArchivedGroupedReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(filterArchivedGroupedReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.pagination;
            })
            .addCase(
                filterArchivedGroupedReservations.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )

            // * filter archived ungrouped reservations
            .addCase(filterArchivedUngroupedReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(
                filterArchivedUngroupedReservations.fulfilled,
                (state, action) => {
                    state.loading = false;
                    state.ungroupedReservations = action.payload.Reservations;
                    state.success = action.payload.Success;
                    state.description = action.payload.Description;
                    state.pagination = action.payload.pagination;
                },
            )
            .addCase(
                filterArchivedUngroupedReservations.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )

            // * unarchive grouped reservations
            .addCase(unarchiveGroupedReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(unarchiveGroupedReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.reservation = action.payload.Reservation;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(
                unarchiveGroupedReservations.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )
            // * unarchive single reservation
            .addCase(unarchiveSingleReservation.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(unarchiveSingleReservation.fulfilled, (state, action) => {
                state.loading = false;
                state.reservation = action.payload.Reservation;
                state.ungroupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(
                unarchiveSingleReservation.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )
            // * export archived reservations
            .addCase(exportArchivedReservationsList.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(exportArchivedReservationsList.fulfilled, (state, action) => {
                state.loading = false;
                state.exportedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(
                exportArchivedReservationsList.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )

            // * get archived event names
            .addCase(getArchivedEventNamesList.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(getArchivedEventNamesList.fulfilled, (state, action) => {
                state.loading = false;
                state.eventNames = action.payload.EventNames;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
            })
            .addCase(
                getArchivedEventNamesList.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )

            // * gc delete multi reservation events
            .addCase(deleteMultipleReservationEvents.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(deleteMultipleReservationEvents.fulfilled, (state, action) => {
                state.loading = false;
                state.groupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(
                deleteMultipleReservationEvents.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            )

            // * gc delete multi reservations
            .addCase(deleteMultipleReservations.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.description = null;
            })
            .addCase(deleteMultipleReservations.fulfilled, (state, action) => {
                state.loading = false;
                state.ungroupedReservations = action.payload.Reservations;
                state.success = action.payload.Success;
                state.description = action.payload.Description;
                state.pagination = action.payload.Pagination;
            })
            .addCase(
                deleteMultipleReservations.rejected,
                (state: any, action: any) => {
                    state.loading = false;
                    state.success = false;
                    state.description = action.payload.Description;
                },
            );
    },
});

export default PartnerReservation.reducer;
